var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgImportedActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#123258",
    fillRule: "evenodd",
    d: "m4.414 17.9 2.894-8.2h12.279l-2.894 8.2zM4 16.067l2.365-6.7a1 1 0 0 1 .943-.667H16.4V7.3h-6.265a2 2 0 0 1-1.664-.89l-.606-.91H4zM17.4 8.7V7.3a1 1 0 0 0-1-1h-6.265a1 1 0 0 1-.832-.445l-.606-.91a1 1 0 0 0-.832-.445H4a1 1 0 0 0-1 1v12.4a1 1 0 0 0 1 1h12.693a1 1 0 0 0 .943-.667l2.894-8.2a1 1 0 0 0-.943-1.333z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE7CA",
    d: "m7.308 9.7-2.894 8.2h12.279l2.894-8.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8BF8E",
    d: "m4 16.067 2.365-6.7a1 1 0 0 1 .943-.667H16.4V7.3h-6.265a2 2 0 0 1-1.664-.89l-.606-.91H4z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImportedActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/imported-active.542946f3.svg";